import type { State } from 'state';

export const getOrganisations = (state: State) => state.persisted.organisations.organisations;
